export default __webpack_public_path__ + "static/media/KTMW-PURPLE.21bbeb0d.pdf";